import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Download } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

// Client-side QR as SVG — vector, so it stays crisp at any print size. This is
// the whole reason the QR is generated in the browser: the SVG string is built
// locally (no network call), shown inline, and offered as a download the user
// drops into their own packaging / paper-manual layout.
export function QrCode({ url, downloadName }: { url: string; downloadName: string }) {
  const { t } = useLanguage();
  const [svg, setSvg] = useState<string>('');

  useEffect(() => {
    let alive = true;
    QRCode.toString(url, { type: 'svg', margin: 1 })
      .then((s) => {
        if (alive) setSvg(s);
      })
      .catch(() => {
        if (alive) setSvg('');
      });
    return () => {
      alive = false;
    };
  }, [url]);

  const download = () => {
    if (!svg) return;
    const blob = new Blob([svg], { type: 'image/svg+xml' });
    const href = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = href;
    a.download = `${downloadName}.svg`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
  };

  if (!svg) return null;

  return (
    <div className="flex flex-col items-center gap-2">
      {/* qrcode emits a self-contained <svg> built from our own URL — render it
          inline so it scales crisply to the container. */}
      <div
        className="h-44 w-44 rounded-lg bg-white p-2"
        dangerouslySetInnerHTML={{ __html: svg }}
      />
      <button
        type="button"
        onClick={download}
        className="flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 transition-colors hover:border-blue-400 hover:text-blue-600"
      >
        <Download className="h-4 w-4" />
        {t('notice.publish.downloadQr')}
      </button>
    </div>
  );
}
